import React from 'react';

const UIKit = React.lazy(() => import('./pages/Main/UIKit/UIKit'));
const Home = React.lazy(() => import('./pages/Main/Home/Home'));

const Login = React.lazy(() => import('./pages/Auth/Login/Login'));
const Register = React.lazy(() => import('./pages/Auth/Register/Register'));
const Activate = React.lazy(() => import('./pages/Auth/Activate/Activate'));
const ForgotPassword = React.lazy(() => import('./pages/Auth/ForgotPassword/ForgotPassword'));
const AcceptInvitation = React.lazy(() => import('./pages/Auth/Accept/AcceptInvitation'));

const LMSHome = React.lazy(() => import('./pages/LMS/LMSHome/LMSHome'));

const Account = React.lazy(() => import('./pages/LMS/Account/Account'));

const InstitutionCreate = React.lazy(() => import('./pages/LMS/Institution/InstitutionCreate/InstitutionCreate'));
const InstitutionDashboard = React.lazy(() => import('./pages/LMS/Institution/InstitutionDashboard/InstitutionDashboard'));
const InstitutionConfiguration = React.lazy(() => import('./pages/LMS/Institution/InstitutionConfiguration/InstitutionConfiguration'));

export const route = [
    {path: '/uiKit', name: 'UIKit', component: UIKit, exact: true},
    {path: '/home', name: 'Home', component: Home, exact: true},

    {path: '/auth/login', name: 'Login', component: Login, exact: true},
    {path: '/auth/register', name: 'Register', component: Register, exact: true},
    {path: '/auth/activate/:type/:status', name: 'Activate', component: Activate, exact: true},
    {path: '/auth/forgotPassword', name: 'Forgot Password', component: ForgotPassword, exact: true},
    {path: '/auth/accept/:role/:token', name: 'Accept Invitation', component: AcceptInvitation, exact: true},

    {path: '/lms/home', name: 'LMS Home', component: LMSHome, exact: true},

    {path: '/lms/account', name: 'LMS User Account', component: Account, exact: true},

    {path: '/lms/institution/create', name: 'LMS Institution Create', component: InstitutionCreate, exact: true},
    {path: '/lms/institution/:institutionId/dashboard', name: 'LMS Institution Dashboard', component: InstitutionDashboard, exact: true},
    {path: '/lms/institution/:institutionId/configuration', name: 'LMS Institution Configuration', component: InstitutionConfiguration, exact: true},
];